module.exports = __webpack_public_path__ + "img/AU.f7c45bee.svg";